import { NavigationBarManager } from "../navigation-bar-manager";
import { Constants } from "./../constants";
import { IScreenStatusCommand } from "./../screen-status-command";
import { RadiobuttonScreenController } from "./radiobutton-screen-controller";

/**
 * Workflow Controller for screen 7 with custom logic
 */
export class Screen7Controller extends RadiobuttonScreenController {

    constructor(index: number, navigationBarManager: NavigationBarManager) {
        super(index, navigationBarManager);
        this.navigationStatus.progressBarGroupIndex = Constants.GROUP_INDEX_2;
    }  

    public calculateNextScreensInFlow(): Array<IScreenStatusCommand> {
        let visibilityChangeRequest: Array<IScreenStatusCommand> = new Array<IScreenStatusCommand>();
        let selectedOption = $(`${this.screenSelector} .FormChoice__Input.FormChoice__Input--Radio:checked`).val();
        switch (selectedOption) {
            case Constants.YES:
                visibilityChangeRequest.push({
                    targetScreenIndex: Constants.SCREEN_9,
                    active: true
                });
                break;

            case Constants.NO:
                visibilityChangeRequest.push({
                    targetScreenIndex: Constants.SCREEN_14,
                    active: true
                });
                break;
        }

        return visibilityChangeRequest;
    }

    public showScreen(): void {
        this.screenDomElement.show();
        this.recordAnalyticsPageViewEvent();
    }
}